import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/referrals-tutorial/content.tsx");
